import { store } from "@/store";
import { GroupRest } from "@/services/rest/group.rest";
import {GroupInterface} from "@/interfaces/Group.interface";

export class GroupService{
    constructor(
        private _groups = new GroupRest()
    ){}

    getGroups(params: any){
        return this._groups.getGroups(params).then((response) => {
            store.dispatch('groups/setGroups', response)
        })
    }

    getGroupById(id: any){
        return this._groups.getGroupById(id).then((response) => {
            store.dispatch('groups/setGroup', response)
        })
    }

    addGroup(data: GroupInterface){
        return this._groups.addGroup(data)
    }

    deleteGroup(id: string): Promise<any>{
        return this._groups.deleteGroup(id).catch((error) => {
            throw error.response.data
        })
    }

    addOrganizationToGroup(id: string, organizationId: string){
        return this._groups.addOrganizationToGroup(id, organizationId)
    }

    removeOrganizationFromGroup(data: any){
        return this._groups.removeOrganizationFromGroup(data)
    }
}